/*
  NOTE for use with AJAX Filter Functionality:

  For Form Submission:
    1. Attach a data-action="filter-buttons#submitForm"
    2. Define event listener for filterFormSubmit as described below in EMITTED EVENTS

  For Existing Filter Selection:
    1. Define event listener for filterSelect as described below in EMITTED EVENTS

  EMITTED EVENTS
    filterFormSubmit (document) Emitted when the form is submitted
      detail: {
        el: the form that triggered the event
      }

    filterSelect (document) Emitted when an filter selection is clicked
      detail: {
        el:       the link element (corresponding to a saved filter) that was clicked,
        filterID: the id of the filter that was clicked
      }
*/

import { createCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['filterSearch', 'currentFilterContainer', 'filtersContainer', 'button', 'filterLink'];

  connect() {
    this.offClickHandler = this.offClickHandler.bind(this);
    this.element.classList.remove('connecting');
  }

  togglePopover(event) {
    event && event.preventDefault();
    const parent = event.currentTarget.parentNode;
    parent.classList.contains('open') ? this.closeButtonPopovers() : this.openAndInitializeForm(parent);
  }

  openNewFilterForm(event) {
    event && event.preventDefault();
    this.openAndInitializeForm(this.filtersContainerTarget, true);
  }

  searchFilters(event) {
    this.filterLinkTargets.forEach(li => {
      li.style.display = this.matchesSearch(li.dataset.title, event.currentTarget.value) ? 'list-item' : 'none';
    });
  }

  closeButtonPopovers(event) {
    event && event.preventDefault();
    this.containerTargets.forEach(container => container.classList.remove('open', 'open-secondary'));
    document.removeEventListener('click', this.offClickHandler);
  }

  submitForm(event) {
    if (document.hasFilterFormSubmitListener) {
      event && event.preventDefault();
      document.dispatchEvent(createCustomEvent('filterFormSubmit', event.target));
    }
  }

  loadSavedFilter(event) {
    if (document.hasFilterSelectListener) {
      event && event.preventDefault();
      document.dispatchEvent(createCustomEvent('filterSelect', event.currentTarget, { filterID: event.target.dataset.filterId }));
    }
  }

  //
  // INTERNAL USE
  //

  openAndInitializeForm(parent, isSecondary=false) {
    this.closeButtonPopovers();
    parent.classList.add(`open${isSecondary ? '-secondary' : ''}`);
    App.addHandlers(parent);
    if (!isSecondary) document.addEventListener('click', this.offClickHandler);
  }

  offClickHandler(event) {
    if (this.elementNotInContainers(event.target) && this.elementNotInButtons(event.target)) this.closeButtonPopovers();
  }

  matchesSearch(text, matchStr) {
    return text.toLowerCase().indexOf(matchStr.toLowerCase()) >= 0
  }

  elementNotInContainers(el) {
    return this.elementNotInCollection(this.containerTargets, el);
  }

  elementNotInButtons(el) {
    return this.elementNotInCollection(this.buttonTargets, el);
  }

  elementNotInCollection(collection, el) {
    return [...collection].reduce((res, container) => res && !container.contains(el), true);
  }

  //
  // GETTERS AND SETTERS
  //

  get containerTargets() {
    return [this.currentFilterContainerTarget, this.filtersContainerTarget];
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/filter-buttons-controller.js